module.exports = __webpack_public_path__ + "images/feature/calendar-3-929a8e08de440c69921af80d35a31c1e.jpg";